<template>
<!-- class="catalogue_pop" v-if="catalogueModel" -->
  <div >
    <van-popup v-model="catalogueModel" position="left" :style="{ height: '100%',width:'89%','max-width':isWeb =='1'?'600px':'','min-width':isWeb =='1'?'500px':''}" >
        <div class="catalogue-content" >
      <div class="title  df-center">报告目录</div>
      <div class="catalogue-list">
        <div class="catalogue-item" v-for="(item,index) in catalogueData" :key="index">
          <!-- 一级 -->
          <div class="catalogue-list-level-1 twoLevel-title" @click="catalogueScroll(item)">
          {{item.title}}
          </div>
          <!-- 二级和三级 -->
          <template v-if="item.children && item.children.length > 0">
            <div v-for="(item2,index2) in item.children" :key="index2">
               <!-- 二级 -->
               <div class="catalogue-list-level-2" @click="catalogueScroll(item2)">
                {{item2.title}}
               </div>
               <!-- 三级 -->
               <template v-if="item2.children && item2.children.length > 0">
                 <div class="catalogue-list-level-3" v-for="(item3,index3) in item2.children" :key="index3" @click="catalogueScroll(item3)">
                   {{item3.title}}
                 </div>
               </template>
            </div>
          </template>
        </div>
      </div>
    </div>
    </van-popup>
     <!-- <yd-popup
      v-model="catalogueModel"
      position="left"
      width="89%"
    >
  
    </yd-popup> -->
  </div>
</template>

<script>
import Vue from 'vue'
// import { Popup } from 'vue-ydui/dist/lib.rem/popup'
// Vue.component(Popup.name, Popup)
import { Popup } from 'vant';

Vue.use(Popup);
export default {
    props: {
        // 目录数据
        catalogueData: {
            type: Array,
            default: () => ([])
        },
        // 父容器安全高度的滚动id
        safeContainerDomId: {
          type: String,
          default: ''
        },
        // iframe模式需要iframe的id
        iframeDomId: {
          type: String,
          default: ''
        },
        isWeb: {
          type: String,
          default: '0'
        },
    },
    data () {
        return {
            // 目录组件显示/隐藏
            catalogueModel: false,
            // 目标距离
            targeTop: 0
        }
    },
    methods: {
      handTouchMove(e) {
        e.preventDefault()
      },
      // 打开目录
      openCatalogue() {
        this.catalogueModel = true
      },
      // 关闭目录
      closeCatalogue() {
        this.catalogueModel = false
      },
      // 目录显示隐藏
      toggleCatalogueStatus(flag =true) {
        this.catalogueModel = flag
      },
      // 兼容目录滚动视图方法
      viewCatalogueScroll(item, safeHeight) {
        // console.log('222加了平滑..');
          let targetDom =  document.getElementById(item.domId)
          setTimeout(() => {
            targetDom.scrollIntoView({behavior: "smooth", block: "center", inline: "center"})
          }, 200);
      },
      // 兼容视图滚动方法
      setScrollTop(scroll_top) {
        document.documentElement.scrollTop = scroll_top;
        window.pageYOffset = scroll_top;
        document.body.scrollTop = scroll_top;
	    },
      // 目录滚动
      catalogueScroll(item) {
        // iframe模式
        if(this.iframeDomId) {
           let scrollIframe =  document.getElementById(this.iframeDomId)
           scrollIframe.contentWindow.postMessage({domId:item.domId},'*')
           setTimeout(() => {
             this.closeCatalogue()
           }, 100);
           return
        }
        // 普通模式
        if(!this.iframeDomId || this.iframeDomId == '') {
          this.closeCatalogue()
          this.viewCatalogueScroll(item)
          return
        }
        
        // 原生实现滚动, 以下的写法在部分真机上会有兼容问题
        return
        // 安全高度
        let safeHeight = document.getElementById(this.safeContainerDomId) && document.getElementById(this.safeContainerDomId).offsetTop || 0
        // console.log(safeHeight,'1111');
         // 安全次数
        let safeCount = 0
        this.toggleCatalogueStatus(false)
        // return
        let domOffsetTop = document.getElementById(item.domId).offsetTop
        let nowTop =
        document.body.scrollTop || document.documentElement.scrollTop; 
      
        if(domOffsetTop > nowTop) {
          safeHeight+=10
          this.scrollDown(item, safeHeight,safeCount)
        } 
        // console.log(domOffsetTop, nowTop,nowTop - domOffsetTop, '差值...');
        if(domOffsetTop < nowTop) {
            safeHeight+=10
            this.scrollUp(item,safeHeight ,safeCount)
        }
        if(nowTop - domOffsetTop > -100 && nowTop - domOffsetTop < 0) {
            this.scrollUp(item,safeHeight ,safeCount)
        }
      },
      // 向下滚
      scrollDown(item,safeHeight,safeCount) {
          safeCount++
          let domOffsetTop = document.getElementById(item.domId).offsetTop
          let nowTop =
          document.body.scrollTop || document.documentElement.scrollTop; 
          if(nowTop < domOffsetTop - safeHeight && safeCount < 100) {
              window.requestAnimationFrame(()=> {this.scrollDown(item, safeHeight,safeCount)});
              let step = nowTop + (domOffsetTop -  nowTop)  / 10
              document.body.scrollTo(0,step);
          }
      },
      // 向上滚
      scrollUp(item,safeHeight,safeCount) {
          safeCount++
          let domOffsetTop = document.getElementById(item.domId).offsetTop
          let nowTop =
          document.body.scrollTop || document.documentElement.scrollTop; 
          if(nowTop  > domOffsetTop - safeHeight && safeCount < 100) {
            window.requestAnimationFrame(()=>{this.scrollUp(item,safeHeight,safeCount)});
            let step =  nowTop - (nowTop -(domOffsetTop - safeHeight) ) /10
            document.body.scrollTo(0,step);
          }
      },
    }
}
</script>

<style lang='scss' scoped>

  .catalogue-text {
    position: fixed;
    z-index: 99999;
    right: 5%;
    bottom: 30%;
    background: rgba(0,0,0,0.5);
  }
  .catalogue-content {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-top: 20px;
    .title {
     height: 44px;
     width: 100%;
     margin-bottom: 0;
     font-size: 19px;
     font-family: PingFangSC, PingFangSC-Medium;
     font-weight: 500;
     color: #333333;
     line-height: 27px;
    //  background-color:pink;
    }
    .catalogue-list {
      flex: 1;
      width: 100%;
      overflow: scroll;
      box-sizing: border-box;
      padding: 0 20px;
      // background:blue;
      // padding-right: 10px;
      .catalogue-list-level-1 {
        min-height: 50px;
        padding-left: 2px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #333333;
        line-height: 23px;
        border-bottom: 1px solid #eeeeee;
      }
      .catalogue-list-level-2 {
        min-height: 50px;
        padding-left: 12px;
        display: flex;
        align-items: center;
        font-size: 15px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #666666;
        line-height: 21px;
        border-bottom: 1px solid #eeeeee;
      } 
      .catalogue-list-level-3 {
        min-height: 50px;
        padding-left: 22px;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #666666;
        line-height: 20px;
        border-bottom: 1px solid #eeeeee;
      }
    }
  }
  .catalogue_pop {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999999;
  }
</style>